import { Show } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';

import { AudioRecorder } from 'shared/components/AudioRecorder';

import { ChatMessageScheduleButton } from '../../ChatMessagesScheduling';
import { ScheduleIcon } from '../../ChatMessagesScheduling/ScheduleIcon';
import { ChatFormSubmitButton } from './SubmitButton';

type ChatFormRecordingModeProps = {
  onRecordingStop: () => void;
  cancelRecording: () => void;
  onSubmit: () => void;
  disabled: boolean;
  isRecordingPaused: boolean;
};

export const ChatFormRecordingMode = ({
  onRecordingStop,
  cancelRecording,
  disabled,
  isRecordingPaused,
  onSubmit,
}: ChatFormRecordingModeProps) => {
  const { isScheduledListVisible: isSchedulingMode } =
    useChatMessageSchedulingContext();

  return (
    <>
      <AudioRecorder
        onRecordingStop={onRecordingStop}
        onRecordingCancel={cancelRecording}
        isRecordingPaused={isRecordingPaused}
      >
        <Show when={!isSchedulingMode}>
          <ChatMessageScheduleButton onClick={onSubmit} />
        </Show>
      </AudioRecorder>
      <ChatFormSubmitButton disabled={disabled}>
        {isSchedulingMode ? (
          <ScheduleIcon iconColor="var(--fgPrimaryInverse)" size="24px" />
        ) : (
          <Icon
            name={iconNames.paperPlane}
            height="18px"
            width="18px"
            stroke="var(--fgPrimaryInverse)"
          />
        )}
      </ChatFormSubmitButton>
    </>
  );
};
